import { ROLES } from '@entities/user';

export class User {
  id;
  ava;
  imgUrl;
  role;
  email;
  subRole;
  lastName;
  firstName;
  compaign;
  campaignId;
  isActivated;
  isConfirmAgreement;
  patreonEmail;
  patronStatus;
  idTier;
  pledges;
  isFreeTrial;
  isGifted;
  lastChargeStatus;
  referralCode;
  referrals;
  tariff;
  freePeriodFrom;
  freePeriodTo;

  constructor(options) {
    this.id = options?.id;
    this.email = options?.email;
    this.imgUrl = options?.imgUrl;
    this.compaign = options?.compaign;
    this.campaignId = +options?.campaignId;
    this.lastName = options?.lastName;
    this.firstName = options?.firstName;
    this.subRole = options?.subRole || '';
    this.role = options?.role || ROLES.USER;
    this.isActivated = +options?.isActivated;
    this.isConfirmAgreement = options?.isConfirmAgreement;
    this.createdAt = new Date(options?.createdAt).getTime();
    this.patreonEmail = options?.patreonEmail;
    this.patronStatus = options?.patronStatus;
    this.idTier = options?.idTier || [];
    this.pledges = options?.pledges || [];
    this.isFreeTrial = options?.isFreeTrial;
    this.isGifted = options?.isGifted;
    this.lastChargeStatus = options?.lastChargeStatus === '0' ? '' : options?.lastChargeStatus;
    this.referralCode = options?.referralCode;
    this.referrals = options?.referrals || [];
    this.tariff = options?.tariff;
    this.freePeriodFrom = +options?.freePeriodFrom;
    this.freePeriodTo = +options?.freePeriodTo;

    if (!options?.ava || options?.ava === 'null') {
        this.ava = null;
    } else {
        this.ava = options?.ava;
    }
  }
}
